import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import { selectUserById, useGetUsersQuery } from '../../store/api/usersApi';

export function Author({ userId }) {
  const { isLoading } = useGetUsersQuery();
  const author = useSelector((state) => selectUserById(state, userId));

  if (isLoading) return <span>Loading...</span>;
  return (
    <Link
      to={`/discover/${author ? author.id : ''}`}
      className="hover:underline"
    >
      <span>{author ? author.name : ''}</span>
    </Link>
  );
}

Author.propTypes = {
  userId: PropTypes.string,
};
